import { Typography, styled } from "@mui/material";
import { Checkbox } from "@mekidoc/ui";
import { privacyPolicyLink, termsAndConditionsLink } from "../constants";

const TermAndConditionsText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "error",
})<{ error: boolean }>(({ error, theme }) => ({
  fontSize: "12px",
  color: error ? theme.palette.error.main : theme.palette.text.secondary,
}));

const Link = styled("a", {
  shouldForwardProp: (prop) => prop !== "error",
})<{ error: boolean }>(({ error, theme }) => ({
  fontSize: "12px",
  textDecorationLine: "underline",
  textAlign: "center",
  color: error ? theme.palette.error.main : theme.palette.text.secondary,
  cursor: "pointer",
}));

interface TermsAndConditionsCheckBoxProps {
  termsChecked: boolean;
  handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: boolean;
}

export const TermsAndConditionsCheckBox = ({
  termsChecked,
  handleCheckboxChange,
  error,
}: TermsAndConditionsCheckBoxProps) => {
  return (
    <Checkbox
      checked={termsChecked}
      onChange={handleCheckboxChange}
      error={error}
      label={
        <TermAndConditionsText error={error}>
          Acepto los{" "}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={termsAndConditionsLink}
            error={error}
          >
            términos y condiciones
          </Link>{" "}
          y las{" "}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={privacyPolicyLink}
            error={error}
          >
            políticas de privacidad
          </Link>
        </TermAndConditionsText>
      }
    />
  );
};
